import React from 'react';
import { Container, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import EntryAuthorizationForm from '../components/EntryAuthorizationForm';

const CreateEntryAuthPage = () => {
  const navigate = useNavigate();
  
  const handleClose = () => {
    navigate('/entry-authorizations');
  };

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Créer une nouvelle autorisation d'entrée
      </Typography>
      
      <EntryAuthorizationForm open={true} onClose={handleClose} />
    </Container>
  );
};

export default CreateEntryAuthPage;
